/* eslint-disable no-untranslated-string/no-untranslated-string */
export const EMeetingTool = {
  'Google Meet': 'GOOGLE_MEET',
  Zoom: 'ZOOM',
  'Microsoft Teams': 'MICROSOFT_TEAMS',
  Webex: 'WEBEX',
  'GoTo Meeting': 'GO_TO_MEETING',
  Other: 'OTHER',
} as const;

export type EMeetingTool = (typeof EMeetingTool)[keyof typeof EMeetingTool];

export const ReverseEMeetingTool = Object.fromEntries(
  Object.entries(EMeetingTool).map(([key, value]) => [value, key]),
) as Record<EMeetingTool, keyof typeof EMeetingTool>;

// Recreate the reverse mapping type using mapped conditional types
export type ReverseEMeetingTool = {
  [V in EMeetingTool]: {
    [K in keyof typeof EMeetingTool]: (typeof EMeetingTool)[K] extends V ? K : never;
  }[keyof typeof EMeetingTool];
};
